import {
  // Checkbox,
  Box,
  ClickAwayListener,
  Fade,
  Popper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Loader } from 'components/loader';
import { SalesRoute } from 'config';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import AssignUserList from './AssignUserList';
import { JobData, MATCH, User } from './utils';

interface JobQueueTableProps {
  data: JobData[];
  selectedRows: string[];
  onRowSelect: (id: string) => void;
  onSelectAll: (selected: boolean) => void;
  loading?: boolean;
  users: User[];
}

const JobQueueTable: React.FC<JobQueueTableProps> = ({
  data,
  selectedRows,
  onRowSelect,
  onSelectAll,
  loading = false,
  users,
}) => {
  const { VIEWipriseJOB } = SalesRoute;
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [skillData, setSkillData] = useState<any[]>([]);
  // const isAllSelected = data.length > 0 && selectedRows.length === data.length;
  // const isIndeterminate =
  //   selectedRows.length > 0 && selectedRows.length < data.length;

  const navigateTo = (jobId: string) => {
    navigate(`${VIEWipriseJOB}/${jobId ?? '1'}`);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>, skills: any[]) => {
    event.stopPropagation();
    // Show skills from index 6 onwards (skills 7, 8, 9, etc.)
    setSkillData(skills.slice(3));
    setAnchorEl(event.currentTarget);
    setOpen((previousOpen) => !previousOpen);
  };

  const canBeOpen = open && Boolean(anchorEl);
  const id = canBeOpen ? 'spring-popper' : undefined;
  // const getStatusBadgeColor = (color: string) => {
  //   switch (color) {
  //     case 'green':
  //       return '#10b981';
  //     case 'orange':
  //       return '#f59e0b';
  //     case 'red':
  //       return '#ef4444';
  //     default:
  //       return '#6b7280';
  //   }
  // };

  const displayData = data.length > 0 ? data : [];

  return (
    <div className="job-queue-table">
      <Table sx={{ minWidth: 650 }} aria-label="job queue table">
        <TableHead>
          <TableRow>
            <TableCell
              sx={{
                '&::after': {
                  backgroundColor: '#e5e7eb',
                  content: '""',
                  height: '24px',
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '2px',
                },
                padding: '12px 16px',
                position: 'relative',
              }}>
              <div style={{ alignItems: 'center', display: 'flex' }}>
                {/* <Checkbox
                  checked={isAllSelected}
                  indeterminate={isIndeterminate}
                  onChange={(e) => onSelectAll(e.target.checked)}
                  sx={{
                    marginRight: '8px',
                    padding: '4px',
                  }}
                /> */}
                <Typography
                  sx={{
                    color: '#000000 !important',
                    fontFamily: 'Red Hat Display semibold !important',
                    fontSize: '13px',
                    fontWeight: 500,
                  }}>
                  Vendor
                </Typography>
              </div>
            </TableCell>
            <TableCell
              sx={{
                '&::after': {
                  backgroundColor: '#e5e7eb',
                  content: '""',
                  height: '24px',
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '2px',
                },
                padding: '12px 16px',
                position: 'relative',
              }}>
              <Typography
                sx={{
                  // color: '181D1F',
                  // fontFamily: 'Red Hat Display regular',
                  // fontSize: '14px',
                  // fontWeight: 500,
                  color: '#000000 !important',
                  fontFamily: 'Red Hat Display semibold !important',
                  fontSize: '13px',
                  fontWeight: 500,
                }}>
                Job Title
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                '&::after': {
                  backgroundColor: '#e5e7eb',
                  content: '""',
                  height: '24px',
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '2px',
                },
                padding: '12px 16px',
                position: 'relative',
              }}>
              <Typography
                sx={{
                  // color: '181D1F',
                  // fontFamily: 'Red Hat Display regular',
                  // fontSize: '14px',
                  // fontWeight: 500,
                  color: '#000000 !important',
                  fontFamily: 'Red Hat Display semibold !important',
                  fontSize: '13px',
                  fontWeight: 500,
                }}>
                Top Skills
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                '&::after': {
                  backgroundColor: '#e5e7eb',
                  content: '""',
                  height: '24px',
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '2px',
                },
                padding: '12px 16px',
                position: 'relative',
              }}>
              <Typography
                sx={{
                  // color: '181D1F',
                  // fontFamily: 'Red Hat Display Medium',
                  // fontSize: '14px',
                  // fontWeight: 500,
                  color: '#000000 !important',
                  fontFamily: 'Red Hat Display semibold !important',
                  fontSize: '13px',
                  fontWeight: 500,
                }}>
                EXP
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                '&::after': {
                  backgroundColor: '#e5e7eb',
                  content: '""',
                  height: '24px',
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '2px',
                },
                padding: '12px 16px',
                position: 'relative',
              }}>
              <Typography
                sx={{
                  // color: '181D1F',
                  // fontFamily: 'Red Hat Display Medium',
                  // fontSize: '14px',
                  // fontWeight: 500,
                  color: '#000000 !important',
                  fontFamily: 'Red Hat Display semibold !important',
                  fontSize: '13px',
                  fontWeight: 500,
                }}>
                Work Auth
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                '&::after': {
                  backgroundColor: '#e5e7eb',
                  content: '""',
                  height: '24px',
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '2px',
                },
                padding: '12px 16px',
                position: 'relative',
              }}>
              <Typography
                sx={{
                  // color: '181D1F',
                  // fontFamily: 'Red Hat Display Medium',
                  // fontSize: '14px',
                  // fontWeight: 500,
                  color: '#000000 !important',
                  fontFamily: 'Red Hat Display semibold !important',
                  fontSize: '13px',
                  fontWeight: 500,
                }}>
                Bill
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                '&::after': {
                  backgroundColor: '#e5e7eb',
                  content: '""',
                  height: '24px',
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '2px',
                },
                padding: '12px 16px',
                position: 'relative',
              }}>
              <Typography
                sx={{
                  // color: '181D1F',
                  // fontFamily: 'Red Hat Display Medium',
                  // fontSize: '14px',
                  // fontWeight: 500,
                  color: '#000000 !important',
                  fontFamily: 'Red Hat Display semibold !important',
                  fontSize: '13px',
                  fontWeight: 500,
                }}>
                Location
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                '&::after': {
                  backgroundColor: '#e5e7eb',
                  content: '""',
                  height: '24px',
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '2px',
                },
                padding: '12px 16px',
                position: 'relative',
              }}>
              <Typography
                sx={{
                  // color: '181D1F',
                  // fontFamily: 'Red Hat Display Medium',
                  // fontSize: '14px',
                  // fontWeight: 500,
                  color: '#000000 !important',
                  fontFamily: 'Red Hat Display semibold !important',
                  fontSize: '13px',
                  fontWeight: 500,
                }}>
                Work Mode
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                '&::after': {
                  backgroundColor: '#e5e7eb',
                  content: '""',
                  height: '24px',
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '2px',
                },
                padding: '12px 16px',
                position: 'relative',
              }}>
              <Typography
                sx={{
                  // color: '181D1F',
                  // fontFamily: 'Red Hat Display Medium',
                  // fontSize: '14px',
                  // fontWeight: 500,
                  color: '#000000 !important',
                  fontFamily: 'Red Hat Display semibold !important',
                  fontSize: '13px',
                  fontWeight: 500,
                }}>
                Job Type
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                '&::after': {
                  backgroundColor: '#e5e7eb',
                  content: '""',
                  height: '24px',
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '2px',
                },
                padding: '12px 16px',
                position: 'relative',
              }}>
              <Typography
                sx={{
                  // color: '181D1F',
                  // fontFamily: 'Red Hat Display Medium',
                  // fontSize: '14px',
                  // fontWeight: 500,
                  color: '#000000 !important',
                  fontFamily: 'Red Hat Display semibold !important',
                  fontSize: '13px',
                  fontWeight: 500,
                }}>
                Status
              </Typography>
            </TableCell>
            <TableCell sx={{ padding: '12px 16px' }} />
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell
                colSpan={11}
                align="center"
                sx={{
                  color: '#241a2e',
                  fontFamily: 'Red Hat Display Bold',
                  fontSize: '14px',
                  padding: '20px',
                  textAlign: 'center',
                }}>
                <Loader newLoader />
              </TableCell>
            </TableRow>
          ) : displayData.length > 0 ? (
            displayData.map((row) => (
              <TableRow
                key={row.id}
                hover
                sx={{
                  '&:hover': {
                    backgroundColor: '#f9fafb',
                  },
                  cursor: 'pointer',
                }}
                onClick={() => navigateTo(row.id)}>
                <TableCell sx={{ padding: '12px 16px' }}>
                  <div style={{ alignItems: 'center', display: 'flex' }}>
                    {/* <Checkbox
                      checked={selectedRows.includes(row.id)}
                      onChange={() => onRowSelect(row.id)}
                      sx={{
                        marginRight: '8px',
                        padding: '4px',
                      }}
                    /> */}
                    <Typography
                      sx={{
                        color: row?.customer?.isTemporary
                          ? '#EF0003'
                          : '#000000',
                        fontFamily: 'Red Hat Display regular',
                        fontSize: '12px',
                        fontWeight: 400,
                        textTransform: 'capitalize',
                      }}>
                      {row?.customer?.name || '-'}
                    </Typography>
                  </div>
                </TableCell>
                <TableCell sx={{ padding: '12px 16px' }}>
                  <Typography
                    sx={{
                      color: '#000000',
                      fontFamily: 'Red Hat Display regular',
                      fontSize: '12px',
                      fontWeight: 400,
                    }}>
                    {row?.jobTitle || '-'}
                  </Typography>
                </TableCell>
                <TableCell sx={{ padding: '12px 16px' }}>
                  {(() => {
                    const allSkills =
                      row?.jobSkills
                        ?.map((skill) => skill?.skill?.name)
                        .filter(Boolean) || [];
                    // Show approximately 2 lines worth of skills (6-8 typically fit)
                    const maxDisplaySkills = 3;
                    const displayedSkills = allSkills.slice(
                      0,
                      maxDisplaySkills,
                    );
                    const displayedNames = displayedSkills.join(', ').trim();
                    const hasMore = allSkills.length > maxDisplaySkills;

                    return (
                      <Typography
                        sx={{
                          color: '#000000',
                          fontFamily: 'Red Hat Display regular',
                          fontSize: '12px',
                          fontWeight: 400,
                          lineHeight: '1.5',
                          marginBottom: '4px',
                          marginRight: '4px',
                          maxWidth: '300px',
                          overflowWrap: 'break-word',
                          padding: '2px 6px',
                          wordWrap: 'break-word',
                        }}>
                        {displayedNames || '-'}{' '}
                        {hasMore && (
                          <button
                            className="more-buttom"
                            aria-describedby={id}
                            type="button"
                            onClick={(e) => handleClick(e, allSkills)}>
                            More...
                          </button>
                        )}
                      </Typography>
                    );
                  })()}
                </TableCell>
                <TableCell sx={{ padding: '12px 16px' }}>
                  <Typography
                    sx={{
                      color: '#000000',
                      fontFamily: 'Red Hat Display regular',
                      fontSize: '12px',
                      fontWeight: 400,
                      minWidth: '80px',
                    }}>
                    {row?.jobDurationTo ? row?.jobDurationTo : '-'}
                    {row?.jobDurationTo && row?.jobDurationTo === 24 ? '+' : ''}
                    {row?.jobDurationTo && ' Months'}
                  </Typography>
                </TableCell>
                <TableCell sx={{ padding: '12px 16px' }}>
                  <Typography
                    sx={{
                      color: '#000000',
                      fontFamily: 'Red Hat Display regular',
                      fontSize: '12px',
                      fontWeight: 400,
                      minWidth: '80px',
                    }}>
                    {row?.jobWorkStatus
                      ?.map((workAuth) => workAuth?.workStatus?.name)
                      ?.filter(Boolean)
                      .join(', ')
                      .trim() || '-'}
                  </Typography>
                </TableCell>
                <TableCell sx={{ padding: '12px 16px' }}>
                  <Typography
                    sx={{
                      color: '#000000',
                      fontFamily: 'Red Hat Display regular',
                      fontSize: '12px',
                      fontWeight: 400,
                      minWidth: '80px',
                    }}>
                    {(() => {
                      const from = Number(row?.payRangeFrom);
                      const to = Number(row?.payRangeTo);
                      if (from > 0 && to > 0) {
                        return `$${from} - $${to}`;
                      } else if (from > 0) {
                        return `$${from}`;
                      } else if (to > 0) {
                        return `$${to}`;
                      } else {
                        return '-';
                      }
                    })()}
                  </Typography>
                </TableCell>
                <TableCell sx={{ padding: '12px 16px' }}>
                  <Typography
                    sx={{
                      color: '#000000',
                      fontFamily: 'Red Hat Display regular',
                      fontSize: '12px',
                      fontWeight: 400,
                    }}>
                    {row?.city || '-'}, {row?.state || '-'}
                  </Typography>
                </TableCell>
                <TableCell sx={{ padding: '12px 16px' }}>
                  <Typography
                    sx={{
                      color: '#000000',
                      fontFamily: 'Red Hat Display regular',
                      fontSize: '12px',
                      fontWeight: 400,
                      minWidth: '80px',
                    }}>
                    {row?.workType === 'Remote'
                      ? 'R'
                      : row?.workType === 'Onsite'
                      ? 'O/S'
                      : 'H'}
                  </Typography>
                </TableCell>
                <TableCell sx={{ padding: '12px 16px' }}>
                  <Typography
                    sx={{
                      color: '#000000',
                      fontFamily: 'Red Hat Display regular',
                      fontSize: '12px',
                      fontWeight: 400,
                    }}>
                    {row?.positionType || '-'}
                  </Typography>
                </TableCell>
                <TableCell sx={{ padding: '12px 16px' }}>
                  <div
                    style={{
                      alignItems: 'center',
                      backgroundColor: MATCH.find(
                        (item) => item.key === row?.candidateMatchStatus,
                      )?.bgColor,
                      borderRadius: '12px',
                      color: 'white',
                      display: 'flex',
                      fontFamily: 'Red Hat Display semibold',
                      fontSize: '12px',
                      fontWeight: 600,
                      justifyContent: 'center',
                      minWidth: '50px',
                      padding: '5px 8px',
                      textAlign: 'center',
                    }}>
                    {row?.totalCandidatesSubmitted}/
                    {row?.totalMatchedCandidates}
                  </div>
                </TableCell>
                <TableCell sx={{ padding: '12px 16px' }}>
                  <AssignUserList row={row} users={users ?? []} />
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={11} align="center" sx={{ padding: '20px' }}>
                <Typography
                  sx={{
                    color: '#6b7280',
                    fontFamily: 'Red Hat Display Regular',
                    fontSize: '14px',
                  }}>
                  No jobs found.
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      {open && (
        <ClickAwayListener onClickAway={() => setOpen(false)}>
          <Popper
            sx={{
              zIndex: 1,
            }}
            id={id}
            open={open}
            anchorEl={anchorEl}
            transition>
            {({ TransitionProps }) => (
              <Fade {...TransitionProps}>
                <Box className={'show-more-box'}>
                  {skillData && skillData.length
                    ? skillData.map((skill: string, index: number) => {
                        return (
                          skill + (index + 1 === skillData.length ? '' : ', ')
                        );
                      })
                    : ''}
                </Box>
              </Fade>
            )}
          </Popper>
        </ClickAwayListener>
      )}
    </div>
  );
};

export default JobQueueTable;
